import { gbp } from './invoiceUtils';

/** Totals + the separate CIS breakdown box (brief §5.4). */
export function InvoiceTotals({ totals, compact = false }) {
  if (!totals) return null;
  const t = totals;
  return (
    <div className="space-y-3" data-testid="invoice-totals">
      <div className="flex items-center justify-between rounded-xl bg-[#1E2530] border border-white/10 px-4 py-3">
        <span className="text-gray-300 text-sm">Invoice total</span>
        <span className="text-xl font-bold text-white tabular-nums" data-testid="invoice-gross-total">{gbp(t.gross_total)}</span>
      </div>
      <div className="rounded-xl border border-white/15 overflow-hidden" data-testid="cis-box">
        <div className="px-4 py-2 bg-white/5 text-xs uppercase tracking-wider text-gray-400 font-semibold">CIS breakdown</div>
        <div className={`px-4 ${compact ? 'py-2 text-xs' : 'py-3 text-sm'} space-y-1.5`}>
          <div className="flex justify-between text-gray-300"><span>Labour (subject to CIS)</span><span className="tabular-nums" data-testid="cis-base">{gbp(t.cis_base)}</span></div>
          <div className="flex justify-between text-gray-300"><span>Materials (not subject to CIS)</span><span className="tabular-nums" data-testid="cis-exempt">{gbp(t.cis_exempt)}</span></div>
          <div className="flex justify-between text-red-300"><span>{t.cis_rate ? `CIS deducted @ ${t.cis_rate}% on labour` : 'CIS — gross status (0%)'}</span><span className="tabular-nums" data-testid="cis-deduction">{t.cis_rate ? `−${gbp(t.cis_deduction)}` : '£0.00'}</span></div>
          <div className="flex justify-between border-t border-white/10 pt-2 text-white font-bold"><span>Amount payable</span><span className="tabular-nums text-[#F5A623]" data-testid="cis-net-payable">{gbp(t.net_payable)}</span></div>
        </div>
      </div>
    </div>
  );
}
